export const STORE = {
  name: "ARJUN RAM HARIJAN",
  shortName: "Arjun Ram Harijan",
  tagline: "Pure Sourcing. Heritage Kirana. Uncompromised Quality.",
  est: "1976",
  email: "arjunram1976@gmail.com",
  phoneDisplay: "+91 94606 62358",
  phoneRaw: "919460662358",
  phoneLocal: "9460662358",
  address: "Shop No. 12, Main Bazaar Road, Near Central Clock Tower, Rajasthan, India",
  hours: [
    { days: "Monday – Saturday", time: "8:00 AM – 9:00 PM" },
    { days: "Sunday", time: "9:00 AM – 6:00 PM" },
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1542838132-92c53300491e?crop=entropy&cs=srgb&fm=jpg&q=85",
  aboutStore: "https://images.unsplash.com/photo-1574586595103-6775e147e412?crop=entropy&cs=srgb&fm=jpg&q=85",
  dairyCans: "https://images.unsplash.com/photo-1776065186452-07da67607249?crop=entropy&cs=srgb&fm=jpg&q=85",
  almondTexture: "https://images.unsplash.com/photo-1602948750761-97ea79ee42ec?crop=entropy&cs=srgb&fm=jpg&q=85",
};
